import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('webisula_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('webisula_cookie_consent', 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('webisula_cookie_consent', 'refused');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto glass-card rounded-2xl p-5 md:p-6 border border-white/10">
            <div className="flex items-start gap-4">
              <div className="hidden sm:flex w-10 h-10 bg-[#8B5A8B]/20 rounded-xl items-center justify-center flex-shrink-0 mt-1">
                <Cookie className="text-[#8B5A8B]" size={20} />
              </div>
              <div className="flex-1">
                <p className="text-white/80 text-sm leading-relaxed">
                  Ce site utilise des cookies pour am{"é"}liorer votre exp{"é"}rience de navigation et {"é"}tablir des statistiques de fr{"é"}quentation.
                  En poursuivant votre navigation, vous acceptez leur utilisation.{' '}
                  <Link to="/politique-confidentialite" className="text-[#8B5A8B] hover:text-[#A16DA1] underline underline-offset-2 transition-colors">
                    Politique de confidentialit{"é"}
                  </Link>
                </p>
                <div className="flex flex-wrap gap-3 mt-4">
                  <button
                    onClick={accept}
                    className="glow-btn text-sm px-6 py-2.5"
                    data-testid="cookie-accept-btn"
                  >
                    Accepter
                  </button>
                  <button
                    onClick={refuse}
                    className="text-sm px-6 py-2.5 border border-white/20 rounded-full text-white/70 hover:text-white hover:border-white/40 transition-colors"
                    data-testid="cookie-refuse-btn"
                  >
                    Refuser
                  </button>
                </div>
              </div>
              <button
                onClick={refuse}
                className="text-white/30 hover:text-white/60 transition-colors flex-shrink-0"
                data-testid="cookie-close-btn"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
